export default __webpack_public_path__ + "static/media/rcta_logo.2fc05ad5.svg";